<template>
  <div class="exchange_coupon">
    <div class="yui_icon">
      <slot name="icon">
        <!--        <img src="../../../../assets/icon-meituan.png" alt="">-->
      </slot>

    </div>
    <div class="coupon-info">
      <h5>{{ name }}</h5>

      <div class="y-link" @click="handToDetail">
        查看细则
        <van-icon name="arrow"
                  size="3vw"/>
      </div>
    </div>

    <div class="yui_ft">
      <p>
        {{ coinNum }}个能量
      </p>
      <van-button round
                  plain
                  class="yui_btn-exchange"
                  hairline
                  :disabled="disBtn"
                  size="mini"
                  color="#2FBD4B"
                  @click="handExchange"
                  type="warning">
        {{disBtn?'暂不可兑':'立即兑换' }}
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  ActivityStartTime
} from "@/config";

export default {
  name: "exchangeCard",
  props: {
    name: {
      type: String
    },
    coinNum: {
      type: [String, Number],
      default: '0'
    },
    productId: {
      type: String
    }
  },
  computed: {
    disBtn() {
      let onDate = Date.now()
 /*     if (this.productId === 'DTQ1' || this.productId === 'DTQ2' || this.productId === 'DTQ3' || this.productId === 'DTQ5') {
        return false
      } else {
        return onDate < 1620266400000
      }*/
      /*活动广告位及相关图片会在6月1日0时上线，但活动开始时间为6月1日17:00，在此之前奖品为无法兑换状态，立即邀请按钮也无法点击邀请；17:00之后按钮恢复正常状态。*/

      return onDate < ActivityStartTime


    }
  },
  methods: {
    handExchange() {
      this.$emit("handExchange");//自定义事件  传递值“子向父组件传值”
    },
    handToDetail() {
      this.$emit("handToDetail",);//自定义事件  传递值“子向父组件传值”
    }
  }
}
</script>

<style lang="less" scoped>
.exchange_coupon {
  display: flex;
  align-items: center;
  position: relative;
  background: #FFF7F3;
  padding: 3vw;
  margin: 3vw;
  border-radius: 2vw;

  &:before {
    position: absolute;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    background-color: #FFFFFF;
    content: " ";
    left: -1.5vw;
    top: calc(50% - 1.5vw);

  }

  &:after {
    position: absolute;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    background-color: #FFFFFF;
    content: " ";
    right: -1.5vw;
    top: calc(50% - 1.5vw);

  }

  .yui_icon {
    width: 7vw;
    margin-right: 2vw;

    img {
      width: 100%;
    }
  }

  .coupon-info {
    flex: 1;

    h5 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #595959;
      line-height: 20px;
    }

    .y-link {

      font-size: 10px;
      font-weight: 400;
      color: #999999;
      line-height: 14px;
      display: inline-flex;
      align-items: center;
    }
  }

  .yui_ft {
    width: 18vw;
    text-align: center;
    position: relative;
    padding-left: 2vw;

    &:before {
      position: absolute;
      content: " ";
      top: 2vw;
      left: 0;
      bottom: 2vw;
      border-left: 1px dashed #F4B18F60;
      //border-left-style:dashed;
    }

    p {
      margin: 0;

      font-size: 2.66vw;
      font-weight: 400;
      color: #2FBD4B;
      line-height: 1.6;
    }
  }
}

.yui_btn-exchange {
  padding-left: 2vw;
  padding-right: 2vw;
  font-size: 3.2vw;
  font-weight: 600;

  background-color: transparent;
}
</style>